import { render, staticRenderFns } from "./SavingElement.vue?vue&type=template&id=f50531fa&"
import script from "./SavingElement.vue?vue&type=script&lang=js&"
export * from "./SavingElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports